import React from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { Text } from '@/components/common/text';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface PaymentCheckboxProps {
  checked: boolean;
  onPress: () => void;
  label: string;
  disabled?: boolean;
}

/**
 * Reusable checkbox component for payment forms
 * Used in credit card and ACH forms for "Make default" option
 */
export const PaymentCheckbox: React.FC<PaymentCheckboxProps> = ({
  checked,
  onPress,
  label,
  disabled = false,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <TouchableOpacity
      style={styles.checkboxRow}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={disabled}
    >
      <View style={styles.checkboxContainer}>
        {checked ? (
          <View style={[styles.checkboxSelected, { backgroundColor: MARKETPLACE_COLORS.checkboxSelected }]}>
            <View style={[styles.checkmark, { borderColor: MARKETPLACE_COLORS.textPrimary }]} />
          </View>
        ) : (
          <View style={[styles.checkboxUnselected, { backgroundColor: MARKETPLACE_COLORS.checkboxBackground, borderColor: MARKETPLACE_COLORS.checkboxBorder }, disabled && styles.checkboxDisabled]} />
        )}
      </View>
      <Text style={[styles.checkboxLabel, { color: MARKETPLACE_COLORS.textPrimary }, disabled && styles.checkboxLabelDisabled]}>
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  checkboxContainer: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxSelected: {
    width: 16,
    height: 16,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkmark: {
    width: 8,
    height: 6,
    borderLeftWidth: 2,
    borderBottomWidth: 2,
    transform: [{ rotate: '-45deg' }],
    marginTop: -2,
  },
  checkboxUnselected: {
    width: 16,
    height: 16,
    borderRadius: 4,
    borderWidth: 1,
  },
  checkboxDisabled: {
    opacity: 0.5,
  },
  checkboxLabel: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  checkboxLabelDisabled: {
    opacity: 0.5,
  },
});

export default PaymentCheckbox;
